import React from 'react'
import {config} from '../config'
const txdomain = config()['tourneyx-url']

const TeamStandingsTeamTab = ({angler, hideAnglerRecord = false}) => {
  //console.log("team-tab record", angler)
  if(angler.hasOwnProperty("team_name")) {
    var {team_name, angler_list, total } = angler
  }
  
  return(
    <td className="team-tab-name">
      {
         <> {team_name} </>
      }
    </td>
  )
}

export default TeamStandingsTeamTab